import { RequestTypeEnum } from '@collections/request-info/enums/request-info.enums';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input} from '@angular/core';
import { ICompany } from '@collections/companies/interfaces';
import { IProduct } from '@collections/products/interfaces';

import { RequestInfoComponent } from 'app/shared/components/request-info/request-info.component';

@Component({
  selector: 'product-request',
  standalone: true,
  imports: [
    RequestInfoComponent
],
  templateUrl: './product-request.component.html',
  styleUrls: ['./product-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductRequestComponent {

  @Input() product: IProduct;
  @Input() company: ICompany;


  requestType = RequestTypeEnum.productRequest;
  constructor(

    ) {
  }

}
